import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BlogPosts.css";
import AuctionList from "../../Components/AuctionList/AuctionList";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BlogPosts = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/blog/posts?published=true`);
        if (!res.ok) throw new Error("Failed to fetch blog posts");
        const payload = await res.json();
        const items = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : [];

        setPosts(items);
        setFilteredPosts(items);
      } catch (err) {
        console.error(err);
        setError("Failed to load blog posts");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  useEffect(() => {
    const q = search.toLowerCase();
    const results = posts.filter((post) => {
      const categories = Array.isArray(post.categories) ? post.categories : [];
      const tags = Array.isArray(post.tags) ? post.tags : [];
      return (
        categories.some((cat) => String(cat).toLowerCase().includes(q)) ||
        tags.some((tag) => String(tag).toLowerCase().includes(q)) ||
        String(post.title || "")
          .toLowerCase()
          .includes(q)
      );
    });
    setFilteredPosts(results);
  }, [search, posts]);

  const handleClick = (post) => {
    navigate(`/blog/${encodeURIComponent(post.slug || post.title)}`, {
      state: { post },
    });
  };

  if (loading) {
    return (
      <div className="loading-spinner-wrapper">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="blog-container">
      <h1 className="blog-title">Latest Blog Posts</h1>

      <input
        type="text"
        placeholder="Search by tag or category..."
        className="blog-search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="blog-list">
        {filteredPosts.map((post, index) => (
          <div
            className="blog-card"
            key={index}
            onClick={() => handleClick(post)}
          >
            <img
              src={post.coverImageUrl}
              alt={post.title}
              className="blog-image"
            />
            <div className="blog-content">
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPosts;
